import PropTypes from 'prop-types';

const hoursEntry = PropTypes.shape({
	day: PropTypes.string,
	open: PropTypes.string,
	close: PropTypes.string,
	timings: PropTypes.string
});

const propDefs = {
	defaults: {
		getModalDisplay: () => {
			return false;
		},
		heading: '',
		hours: {
			default: [],
			parts: [],
			service: []
		},
		onHide: () => {},
		show: true,
		showModal: false
	},

	settings: {
		department: PropTypes.string,
		getModalDisplay: PropTypes.func,
		heading: PropTypes.string,
		hideModal: PropTypes.func,
		hours: PropTypes.objectOf(PropTypes.arrayOf(hoursEntry)),
		hoursArray: PropTypes.array,
		modal: PropTypes.shape({
			showModal: PropTypes.bool
		}),
		onHide: PropTypes.func,
		prefs: PropTypes.shape({
			allHoursDepts: PropTypes.string,
			allHoursLabelIds: PropTypes.string,
			showDepartmentsViewAllLink: PropTypes.string,
			showSunday: PropTypes.string,
			shrinkIdenticalHours: PropTypes.string,
			'department.id': PropTypes.string
		}),
		setHours: PropTypes.func,
		show: PropTypes.bool,
		showModal: PropTypes.bool
	},

	hoursEntry
};

export default propDefs;



// WEBPACK FOOTER //
// ./src/proptypes/index.js